import type { LocalizedStringMap } from '@/types/locale';

export type EstablishmentType = 'RESTAURANT' | 'HOTEL' | 'BAR' | 'OTHER';
export type PointsMode = 'card' | 'order';
export type MenuScope = 'global' | 'location';

export interface Establishment {
  uuid: string;
  slug: string;

  name: string;
  description: string;
  name_i18n?: LocalizedStringMap;
  description_i18n?: LocalizedStringMap;
  type: EstablishmentType;
  logo?: string;
  logo_uuid?: string;
  logo_background_color?: string;
  hero_image?: string;
  hero_image_uuid?: string;
  website?: string;
  is_active: boolean;
  points_mode?: PointsMode;
  points_per_euro_scan?: number;
  points_per_euro_order?: number;
  menu_scope?: MenuScope;
  locations?: Location[];
  menu_categories_count?: number;
  created_at: string;
  updated_at: string;
}

export interface Location {
  uuid: string;
  slug?: string;
  establishment_uuid: string;
  name: string;
  details_uuid: string;
  details?: LocationDetails;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface LocationDetails {
  uuid: string;
  address: string;
  email: string;
  phone: string;
  longitude: number;
  latitude: number;
  working_hours?: WorkingHours[];
  created_at: string;
  updated_at: string;
}

export interface WorkingHours {
  uuid: string;
  details_uuid: string;
  day_from: number;
  day_to: number;
  time_from: string;
  time_to: string;
  created_at: string;
  updated_at: string;
}

export interface EstablishmentRequest {
  slug?: string;
  name?: string;
  description?: string;
  name_i18n: LocalizedStringMap;
  description_i18n: LocalizedStringMap;
  type: EstablishmentType;
  logo?: string;
  logo_uuid?: string;
  logo_background_color?: string;
  hero_image?: string;
  hero_image_uuid?: string;
  website?: string;
  points_mode?: PointsMode;
  points_per_euro_scan?: number;
  points_per_euro_order?: number;
  menu_scope?: MenuScope;
}

export interface LocationRequest {
  name: string;
  details: LocationDetailsRequest;
}

export interface LocationDetailsRequest {
  address: string;
  email: string;
  phone: string;
  longitude: number;
  latitude: number;
  working_hours: WorkingHoursRequest[];
}

export interface WorkingHoursRequest {
  day_from: number;
  day_to: number;
  time_from: string;
  time_to: string;
}

export interface WorkingHoursUI {
  day: string;
  open: string;
  close: string;
}

export const DayMap: Record<number, string> = {
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
  7: 'sunday'
}

export const DayStringToNumber: Record<string, number> = {
  'MONDAY': 1,
  'TUESDAY': 2,
  'WEDNESDAY': 3,
  'THURSDAY': 4,
  'FRIDAY': 5,
  'SATURDAY': 6,
  'SUNDAY': 7
}

export const DayNumberToString: Record<number, string> = {
  1: 'MONDAY',
  2: 'TUESDAY',
  3: 'WEDNESDAY',
  4: 'THURSDAY',
  5: 'FRIDAY',
  6: 'SATURDAY',
  7: 'SUNDAY'
}